import { Arc, ArcT, BasicControl, CURSOR_TYPE, CaptureTagType, CircleT, Curve3, DYMODE_MODE, Line, LineT, Listeners, MOUSE, ModelBase, Plane, PlineT, Point, RegionT, TnEngineContext, TnEngineExtraContext, ViewEditor, dymode } from "pytha";
import { ARCHI_CTRL_TYPE } from "../enums/archibase-control-type";
import { Vector3 } from "three";
import { ARCHIBASE_SINGAL } from "../enums/archibase-singal";
import { MonitorColorRegionT } from "../models/monitor-object/MonitorRegionT";

/**
 * 选天沟监测对象二级控制器
 * 
 * 方式：选择角点生成面域
 */
export class SelectGutterMonitorObjectControl extends BasicControl {
    id = ARCHI_CTRL_TYPE.ADD_GUTTER_MONITOR_OBJECR;

    needInit: boolean;  // 是否需要初始化数据

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    capturePoint: Vector3;  // 捕捉点
    orthogonalPoint: Vector3; // 正交点
    polarPoint: Vector3; // 极轴追踪点


    helpLines: LineT[] = []; // 临时辅助线集合

    firstPoint: Point = new Point(); // 第一个点坐标
    secondPoint: Point = new Point(); // 第二个点坐标
    thirdPoint: Point = new Point(); // 第三个点坐标

    plane: Plane = new Plane();

    point_down: Point = new Point();
    point_move: Point = new Point();
    lastPoint: Point = new Point();

    step: number = 1;

    needCreate: boolean = false; // 闭合创建

    options = {
        1: [
            { name: '放弃', key: 'U', tips: '指定第1个点:' },
        ],
        2: [
            { name: '放弃', key: 'U', tips: '指定第2个点:' },
        ],
        3: [
            { name: '放弃', key: 'U', tips: '指定第3个点:' },
        ],
        4: [
            { name: '闭合', key: 'C', tips: '指定下一个点:' },
            { name: '放弃', key: 'U' }
        ],
    }

    // 构造函数
    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        this.needInit = false;

        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();

        this.editor = editor;
        this.listeners = listeners;

        this.editor.clampControl.enabled = false;
        this.editor.clampControl.hidden = true;

        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        this.listeners.signals.emptySelectedEntities.dispatch();
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        this.listeners.signals.onPointOrthogonal.add(this.onPointOrthogonal);
        // 订阅极轴追踪信号，收听到极轴追踪点的坐标
        this.listeners.signals.onPointPolarTracking.add(this.onPointPolarTracking);

        this.extraContext.dymodeContext.setMode(DYMODE_MODE.POINT);
        this.point_down.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        this.point_move.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);

        this.listeners.signals.needCapture.dispatch();
        this.editor.selectControl.setEnabled(false);
        this.extraContext.dymodeContext.enabled = true;
        this.step = 1;
        this.listeners.signals.sendToDymodeTip.dispatch(this.options[this.step][0].tips);
        this.extraContext.stmodeContext.setStmode(this.options[this.step][0].tips);
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);

        console.log('SelectGutterMonitorObjectControl added')

    }

    // 析构函数
    dispose(): void {
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onPointOrthogonal.remove(this.onPointOrthogonal);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onPointPolarTracking.remove(this.onPointPolarTracking);
        this.listeners.signals.noNeedCapture.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.orthogonalControl.enabled = false;

        this.editor.clampControl.enabled = true;
        this.editor.clampControl.hidden = false;

        if (this.needCreate) {
            // 使用线生成面域
            let region = this.generateRegion(this.helpLines.map(line => line.clone()).filter(line => line._geo.delta().length() > 1e-6))
            this.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish).dispatch(region);
        } else {
            this.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish).dispatch(null);
        }
        this.helpLines.forEach(line => {
            if (line && line.viewObj && line.viewObj.parent) {
                line.viewObj.parent.remove(line.viewObj);
            }
        });
        console.log('SelectGutterMonitorObjectControl removed')
    }
    generateRegion = (entities: ModelBase[]) => {
        let edges: Curve3[] = [];
        for (let entity of entities) {
            if (entity.type === 'PlineT') {
                (entity as PlineT)._geoCurves.forEach(curve => {
                    if (curve.type === 'Line') {
                        const line = new Line((curve as Line).start, (curve as Line).end);
                        edges.push(line);
                    } else {
                        edges.push((curve as Arc));
                    }
                })
            } else if (entity.type === 'LineT') {
                let tmp = entity as LineT;
                edges.push(tmp._geo);
            } else if (entity.type === 'ArcT') {
                let tmp = entity as ArcT;
                edges.push(tmp._geo);
            } else if (entity.type === 'CircleT') {
                let tmp = entity as CircleT;
                edges.push(tmp._geoCircle);
            }
        }
        let region = new MonitorColorRegionT(edges);
        return region;
    }

    //临时图元没有捕捉点，但是该二级控制器需要临时图元的捕捉点以达到闭合的目的
    updateCapturePoint = () => {
        this.editor.captureControl.onEmptyOutsideCapture();
        for (let i = 0; i < this.helpLines.length; i++) {
            let line = this.helpLines[i];
            const middlePoint = new Vector3();
            middlePoint.x = (line._geo.start.x + line._geo.end.x) / 2;
            middlePoint.y = (line._geo.start.y + line._geo.end.y) / 2;
            middlePoint.z = (line._geo.start.z + line._geo.end.z) / 2;
            if (i === this.helpLines.length - 1) {
                this.editor.captureControl.outsideEntityCaptureNormalPoints[line.uuid] = [
                    { point: new Vector3().copy(line._geo.start), type: CaptureTagType.END_POINT },
                    { point: middlePoint, type: CaptureTagType.END_POINT },
                    { point: new Vector3().copy(line._geo.end), type: CaptureTagType.END_POINT }
                ]
            } else {
                this.editor.captureControl.outsideEntityCaptureNormalPoints[line.uuid] = [
                    { point: new Vector3().copy(line._geo.start), type: CaptureTagType.END_POINT },
                    { point: middlePoint, type: CaptureTagType.END_POINT },
                ]
            }
        }
    }

    onPointPolarTracking = (point) => {
        this.polarPoint = point;
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    onPointOrthogonal = (point) => {
        this.orthogonalPoint = point;
    }

    private _lastPointDown: Point = new Point();

    // 鼠标按下
    onPointerDown = (event) => {
        if (event.button === MOUSE.RIGHT) {
            this.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        if (event.button !== MOUSE.LEFT) return;
        this._lastPointDown.copy(this.point_down.clone());
        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let x = (event.clientX - rect.x) / rect.width * 2 - 1;
        let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
        this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_down);
        if (this.orthogonalPoint) {
            this.point_down.copy(this.orthogonalPoint);
        }
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
        }
        if (this.polarPoint) {
            this.point_down.copy(this.polarPoint);
        }
        if (this.step === 1) {
            // 获得了第一个点坐标
            this.firstPoint = this.point_down.clone();
            this.addHelpLine();
        } else if (this.step === 2) {
            // 获得了第二个点坐标
            if (!this._lastPointDown.equals(this.point_down)) {
                // 与上一点不同，下一步
                this.secondPoint = this.point_down.clone();
                this.addHelpLine();
            }
        } else if (this.step === 3) {
            // 获得了第三个点坐标
            if (!this._lastPointDown.equals(this.point_down)) {
                // 与上一点不同，下一步
                this.thirdPoint = this.point_down.clone();
                this.thirdStep();
            }
        } else if (this.step === 4) {
            if (!this._lastPointDown.equals(this.point_down)) {
                // 与上一点不同，下一步
                // 获得了第四个点坐标或之后的点坐标，需投影到之前点生成的平面上
                this.plane.projectPoint(this.point_down, this._foot);
                this.point_down.copy(this._foot);
                this.fourthStep();
            }
        }

    }

    private _foot = new Point();
    // 鼠标移动
    onPointerMove = (event) => {
        if (this.step === 1) return;
        this.point_move.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        if (this.orthogonalPoint) {
            this.point_move.copy(this.orthogonalPoint);
        }
        if (this.polarPoint) {
            this.point_move.copy(this.polarPoint);
        }
        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        }
        if (this.step == 4) {
            // 此时根据前三个点生成了平面，后续的点全部会投影到这个平面上
            this.plane.projectPoint(this.point_move, this._foot);
            this.point_move.copy(this._foot);
        }
        if (this.helpLines.length > 0) {
            let line = this.helpLines[this.helpLines.length - 1];
            line._geo.end.copy(this.point_move);
            line.updateViewGeometry();
            this.editor.listeners.signals.needRender.dispatch();
        };
    }

    //闭合底面
    closePolygon = () => {
        let start = this.helpLines[0]._geo.start.clone();
        this.helpLines[this.helpLines.length - 1]._geo.end.copy(start);
        this.helpLines.push(new LineT(start, start.clone()))
    }

    // 指定了点之后，添加辅助线
    addHelpLine = () => {
        // 构造辅助线
        let newLine = new LineT(new Point().copy(this.point_down), new Point().copy(this.point_down));
        this.helpLines.push(newLine);
        this.extraContext.sceneContext.scene.add(newLine.render());
        this.editor.listeners.signals.needRender.dispatch();
        // 下一步
        this.step++;
        this.listeners.signals.sendToDymodeTip.dispatch(this.options[this.step][0].tips);
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
        this.extraContext.stmodeContext.setStmode(this.options[this.step][0].tips, this.options[this.step] || []);
        this.updateCapturePoint();
        this.listeners.signals.polarTracking.dispatch(this.point_down);
        this.listeners.signals.orthogonal.dispatch(this.point_down);
        this.listeners.signals.needCapture.dispatch(this.point_down);
    }

    // 指定了第三个点坐标
    thirdStep = () => {
        let newLine = new LineT(new Point().copy(this.point_down), new Point().copy(this.point_down));
        // 判断三点是否共线，如果不共线可生成面域所在平面
        let dir1 = new Vector3().subVectors(this.secondPoint, this.firstPoint);
        let dir2 = new Vector3().subVectors(this.thirdPoint, this.firstPoint);
        let crossLength = dir1.cross(dir2).length();
        if (crossLength < 1e-6) {
            // 叉积长度为0，三点共线，需要继续指定点，step不加1了，还是第三步，指定平面的第三个点
        } else {
            // 不共线，根据三点生成平面，下一步，指定其他角点
            this.plane.setFromCoplanarPoints(this.firstPoint, this.secondPoint, this.thirdPoint);
            this.step++;
        }
        this.helpLines.push(newLine);
        this.extraContext.sceneContext.scene.add(newLine.render());
        this.editor.listeners.signals.needRender.dispatch();
        this.listeners.signals.sendToDymodeTip.dispatch(this.options[this.step][0].tips);
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
        this.extraContext.stmodeContext.setStmode(this.options[this.step][0].tips, this.options[this.step] || []);
        this.updateCapturePoint();
        this.listeners.signals.polarTracking.dispatch(this.point_down);
        this.listeners.signals.orthogonal.dispatch(this.point_down);
        this.listeners.signals.needCapture.dispatch(this.point_down);
    }

    // 指定了其他角点
    fourthStep = () => {
        if (this.point_down.equals(this.firstPoint)) {
            // 与第一点相同，直接闭合
            this.needCreate = true;
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        // 构造辅助线
        let newLine = new LineT(new Point().copy(this.point_down), new Point().copy(this.point_down));
        this.helpLines.push(newLine);
        this.extraContext.sceneContext.scene.add(newLine.render());
        this.editor.listeners.signals.needRender.dispatch();
        // 继续指定角点
        this.step = 4;
        this.listeners.signals.sendToDymodeTip.dispatch(this.options[this.step][0].tips);
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
        this.extraContext.stmodeContext.setStmode(this.options[this.step][0].tips, this.options[this.step] || []);
        this.updateCapturePoint();
        this.listeners.signals.polarTracking.dispatch(this.point_down);
        this.listeners.signals.orthogonal.dispatch(this.point_down);
        this.listeners.signals.needCapture.dispatch(this.point_down);
    }

    _dymodeActive = false;

    onDymodeChanged = (value: dymode) => {
        if (value.mode === DYMODE_MODE.POINT) {
            this._lastPointDown.copy(this.point_down.clone());
            this.point_down.set(value.x, value.y, value.z);
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        } else if (value.mode === DYMODE_MODE.DIST) {
            let dir = this.point_move.clone().sub(this.point_down).normalize();
            let end = dir.multiplyScalar(value.dist).add(this.point_down);
            this._lastPointDown.copy(this.point_down.clone());
            this.point_down.set(end.x, end.y, end.z);
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        } else if (value.mode === DYMODE_MODE.CHOOSE) {
            let choose = value.choose.toUpperCase();
            switch (choose) {
                case 'U':
                    // 放弃
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                    break;
                case 'C':
                    // 闭合
                    this.needCreate = true;
                    this.closePolygon();
                    this.onKeyMouseConfirm();
                    // this.listeners.signals.onOpeCommandControlEnd.dispatch();
                    break;
            }
        }
    }

    onKeyMouseConfirm = () => {
        if (this.step === 1) {
            if (!this._dymodeActive) {
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
            } else {
                // 获得了第一个点坐标
                this.firstPoint = this.point_down.clone();
                this.addHelpLine();
                this._dymodeActive = false;
            }
        } else if (this.step === 2) {
            if (!this._dymodeActive) {
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
            } else {
                // 获得了第二个点坐标
                this._dymodeActive = false;
                if (!this._lastPointDown.equals(this.point_down)) {
                    // 与上一点不同，下一步
                    this.secondPoint = this.point_down.clone();
                    this.addHelpLine();
                }
            }
        } else if (this.step === 3) {
            if (!this._dymodeActive) {
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
            } else {
                // 获得了第三个点坐标
                this._dymodeActive = false;
                if (!this._lastPointDown.equals(this.point_down)) {
                    // 与上一点不同，下一步
                    this.thirdPoint = this.point_down.clone();
                    this.thirdStep();
                }
            }
        } else if (this.step === 4) {
            if (this._dymodeActive) {
                // 与上一点不同，下一步
                // 获得了第四个点坐标或之后的点坐标，需投影到之前点生成的平面上
                this.plane.projectPoint(this.point_down, this._foot);
                this.point_down.copy(this._foot);
                this.fourthStep();
                this._dymodeActive = false;
            } else if (this.needCreate) {
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
            }
        }
    }
}

